import { useCallback, useState } from "react";
import { useEquipmentStore } from "../../store/equipment";
import useGetInspection from "../work-order/inspection/useGetInspection";
import useGetTestEquipmentListAndRule from "../work-order/inspection/useGetTestEquipmentListAndRule";

export default function useDownloadEquipmentInspections() {
  const [isDownloading, setIsDownloading] = useState(false);
  const { getInspection } = useGetInspection();
  const { getTestEquipmentListAndRule } = useGetTestEquipmentListAndRule();

  const trigger = useCallback(async () => {
    setIsDownloading(true);
    const selectedInspections = useEquipmentStore.getState().selectedInspection;
    for (const ins of selectedInspections) {
      const { id, equipmentId } = ins;
      await getInspection(id, id.toString(), {
        isEquipmentContext: true,
        equipmentId: equipmentId,
      });
    }
    await getTestEquipmentListAndRule();
    setIsDownloading(false);
  }, [getInspection, getTestEquipmentListAndRule]);

  return {
    trigger,
    isDownloading,
  };
}
